export default __webpack_public_path__ + "static/media/congratsKeto.fa6b300c.svg";